import { doc, runTransaction } from 'firebase/firestore';
import { getEnemyStatsDocRef } from './mirrorSyncService';

const getYearFromDate = (value) => {
  const parsed = new Date(value);
  if (Number.isNaN(parsed.getTime())) return null;
  return String(parsed.getFullYear());
};

export const deleteEnemyStatsWithMirror = async ({
  db,
  teamId,
  seasonId,
  modeId,
  mirrorId,
  mirrorExists,
}) => {
  const modeRef = getEnemyStatsDocRef(db, teamId, seasonId, modeId);
  const mirrorRef = mirrorId ? getEnemyStatsDocRef(db, teamId, seasonId, mirrorId) : null;

  await runTransaction(db, async (tx) => {
    const modeSnap = await tx.get(modeRef);
    const modeData = modeSnap.exists() ? (modeSnap.data() || {}) : {};

    tx.delete(modeRef);

    // If this is an explicit mirror pair, delete mirror counterpart as well.
    if (mirrorId && mirrorExists && mirrorRef) {
      tx.delete(mirrorRef);
    }

    // If this is a reciprocal enemy record created from team summary, delete source team summary too.
    const sourceModeId = String(modeData.sourceModeId || '').trim();
    const sourceSeasonId = String(modeData.sourceSeasonId || '').trim();
    const isTeamSummarySource =
      modeData.source === 'teamSummaryReciprocal' &&
      modeData.sourceCollection === 'teamStats' &&
      !!sourceModeId;

    if (isTeamSummarySource) {
      const seasonCandidates = [
        sourceSeasonId,
        seasonId,
        modeData.SeasonId,
        getYearFromDate(modeData.Date),
      ]
        .map((value) => String(value || '').trim())
        .filter(Boolean);

      let linkedRef = null;
      for (const seasonKey of [...new Set(seasonCandidates)]) {
        const candidateRef = doc(db, `teams/${teamId}/seasons/${seasonKey}/database/teamStats/modes/${sourceModeId}`);
        const candidateSnap = await tx.get(candidateRef);
        if (candidateSnap.exists()) {
          linkedRef = candidateRef;
          break;
        }
      }

      if (!linkedRef) {
        const legacyRef = doc(db, `teams/${teamId}/database/teamStats/modes/${sourceModeId}`);
        const legacySnap = await tx.get(legacyRef);
        if (legacySnap.exists()) {
          linkedRef = legacyRef;
        }
      }

      if (linkedRef) {
        tx.delete(linkedRef);
      }
    }
  });
};
